import React from "react";
import { LangContext } from "../../contexts/LangContext";
import en from "../../i18n/en";
import pl from "../../i18n/pl";

export function PageHeader({ page, scraping_tokens, ai_tokens, onShowSupport }) {
  const { lang } = React.useContext(LangContext);
  const t = lang === "pl" ? pl : en;

  const titles = {
    'tasks': t.tasksList,
    'create': t.newTaskTitle,
    'balance': t.balanceTitle,
    'visualization': t.visualizationTitle,
    'select-create': t.newTaskTitle,
    'referrals': t.referralsPage.name
  };

  const subtitles = {
    tasks: t.tasksDesc,
    create: t.tasksDesc,
    balance: t.balanceAndCredits, // нужно добавить этот ключ в оба файла локализации
    visualization: t.visualizeAndAnalyze, // нужно добавить этот ключ в оба файла локализации
  };

  return (
    <div className="page-header">
      <div>
        <h1>{titles[page] || page}</h1>
        <p>{subtitles[page] || ""}</p>
      </div>
      <div className="header-actions">
        <div className="quota-pill">
          <span className="quota-label">{t.PageHeader.scrapingLabel}</span> {/* нужно добавить */}
          <span className="quota-nums">{Number(scraping_tokens).toFixed(2)}</span>
        </div>
        <div className="quota-pill">
          <span className="quota-label">{t.PageHeader.aiLabel}</span> {/* нужно добавить */}
          <span className="quota-nums">{Number(ai_tokens).toLocaleString()}</span>
        </div>
        <button className="btn-icon" title={t.support} onClick={onShowSupport}>
          💬
        </button>
      </div>
    </div>
  );
}